// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ndPn","label":"styles_label__1qWtf"};